// import PropTypes from 'prop-types';
// material-ui
import { DialogContent } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import React from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// styles
import styles from "./styles";

const useStyles = makeStyles(styles);

export default function RichText({ onSave, value }) {
  let es;
  if (value) {
    const html = value;
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      es = EditorState.createWithContent(contentState);
    }
  }
  const [editorState, setEditorState] = React.useState(
    es ? es : () => EditorState.createEmpty()
  );
  const [open, setOpen] = React.useState(false);
  const classes = useStyles(styles);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const theme = useTheme();

  const handleClose = () => {
    onSave(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    setOpen(false);
  };

  return (
    <div>
      <div
        onClick={handleClickOpen}
        style={{
          border: "1px solid transparent",
          borderRadius: 4,
          background: `linear-gradient(${
            theme.palette.type === "dark" ? "#303030,#303030" : "white,white"
          }) padding-box, linear-gradient(to bottom right, #f44336 0%, #ff9800 25%, #8bc34a 50%, #03a9f4 75%, #3f51b5 100%) border-box`,
          maxHeight: 300,
          minHeight: 32,
          overflow: "scroll",
          padding: 8,
          cursor: "pointer",
        }}
      >
        <div
          style={{ background: "white" }}
          dangerouslySetInnerHTML={{
            __html: draftToHtml(convertToRaw(editorState.getCurrentContent())),
          }}
        />
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        maxWidth="md"
        fullWidth
        classes={{
          paper: classes.paper,
        }}
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{ padding: 0, display: "flex" }}>
          <Editor
            editorState={editorState}
            toolbar={{
              fontFamily: {
                options: [
                  "kimi",
                  "museo-sans",
                  "Arial",
                  "Georgia",
                  "Impact",
                  "Tahoma",
                  "Times New Roman",
                  "Verdana",
                ],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
              },
            }}
            onEditorStateChange={setEditorState}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            autoFocus
            variant="contained"
            color="primary"
            style={{
              textTransform: "none",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
